export default __webpack_public_path__ + "static/60_months-47c203000c4bbe929e8822c21c903f2e.jpeg";